module.exports = __webpack_public_path__ + "static/media/ic_notifications_active_24px.25974e6e.svg";